import { render, staticRenderFns } from "./CarregaOrdreEixida.vue?vue&type=template&id=306ada8e&scoped=true"
import script from "./CarregaOrdreEixida.vue?vue&type=script&lang=js"
export * from "./CarregaOrdreEixida.vue?vue&type=script&lang=js"
import style0 from "./CarregaOrdreEixida.vue?vue&type=style&index=0&id=306ada8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ada8e",
  null
  
)

export default component.exports